module.exports = __webpack_public_path__ + "img/home_page_user_img.8f91d59d.png";